



import CoDashboard from '@/components/Organisms/co-dashboard/CoDashboard.vue';

export default {
    name: 'AdminStatisticsRevenue',
    components: {
        CoDashboard,
    },
};
